module.exports = "/_next/static/images/d985dcb017de0c744ff04a086c8c3cfd-woman-with-yellow-glasses@2x.jpg";